export type CatalogDuplicateFingerprint = Readonly<Record<string, unknown>>;

export function getDuplicateCatalogColors<T extends { readonly id?: unknown }>(
  items: readonly T[],
  createFingerprint: (item: T) => CatalogDuplicateFingerprint
): ReadonlyMap<string, string> {
  const groups = items.reduce((result, item) => {
    const id = item.id == null ? '' : String(item.id);
    if (!id) {
      return result;
    }

    const key = JSON.stringify(createFingerprint(item));
    result.set(key, [...(result.get(key) ?? []), id]);
    return result;
  }, new Map<string, string[]>());

  return [...groups.entries()]
    .filter(([, ids]) => ids.length >= 2)
    .sort(([leftKey], [rightKey]) => leftKey.localeCompare(rightKey))
    .reduce((result, [, ids], groupIndex) => {
      const hue = Math.round((groupIndex * 137.508) % 360);
      const color = `hsla(${hue}, 72%, 55%, 0.22)`;
      ids.forEach(id => result.set(id, color));
      return result;
    }, new Map<string, string>());
}